import type React from "react";
import type { RootState } from "../store";
import { fetchCities } from "../store/features/citySlice";
import CityTable from "../components/cities/CityTable";
import CreateCityForm from "../components/cities/CreateCityForm";
import { createCityApi, updateCityApi } from "../api/citiesApi";
import SimpleCrudPage from "../components/common/SimpleCrudPage";

const LocationsPage: React.FC = () => {
  return (
    <SimpleCrudPage
      titleTranslationKey="cities.title"
      addButtonTranslationKey="Add Location"
      fetchAction={fetchCities}
      createApi={createCityApi}
      updateApi={updateCityApi}
      selector={(state: RootState) => ({
        items: state.cities.cities,
        loading: state.cities.loading,
      })}
      createErrorContext="createCity"
      updateErrorContext="updateCity"
      createSuccessMessage="Location created successfully"
      updateSuccessMessage="Location updated successfully"
      TableComponent={CityTable}
      FormComponent={CreateCityForm}
    />
  );
};

export default LocationsPage;
